(function availableLots(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};

  if (!global.NewHomeSource.Event ||
    Object.hasOwnProperty.call(window, "ActiveXObject")
    && !window.ActiveXObject) {
    return;
  }

  const queryLotSectionOpeners = '[data-open-lot-gallery]';
  const triggerButton = global.document.getElementById('nhs_map');

  const eventsConfiguration = {
    availableButton: {
      callbacks: [global.NewHomeSource.Event.clickElement.bind(null, triggerButton)],
      events: ['click', 'touchend'],
      elements: queryLotSectionOpeners,
    },
  };

  global.NewHomeSource.Event(eventsConfiguration);
}(window));